import React, { useState, useEffect, useRef } from "react";
import { MuiOtpInput } from "mui-one-time-password-input";
import { FormHelperText, styled } from "@mui/material";
import { isRequired } from "../../utils/validator";
import { useLocation } from "react-router";

const MuiOtpInputStyled = styled(MuiOtpInput)`
  display: flex;
  gap: 30px;
  max-width: 650px;
  margin-inline: auto;
`;

const RESEND_WAIT_SECONDS = 120; // 02 minutes

export default function Otp(props) {
    const [otp, setOtp] = useState('');
    const [emailError, setEmailError] = useState('');
    const [remainingTime, setRemainingTime] = useState(RESEND_WAIT_SECONDS);
    const [isResendDisabled, setIsResendDisabled] = useState(true);
    // Absolute deadline instead of a tick counter: background tabs get their
    // timers throttled, so counting setInterval ticks loses seconds.
    const deadlineRef = useRef(Date.now() + RESEND_WAIT_SECONDS * 1000);
    const location = useLocation();

    const handleOtpChange = (value) => {
        let error = "";
        error = isRequired(value, "code");

        setEmailError(error);
        setOtp(value);
    };

    useEffect(() => {
        if (!isResendDisabled) return undefined;

        const tick = () => {
            const secondsLeft = Math.max(
                Math.ceil((deadlineRef.current - Date.now()) / 1000),
                0
            );
            setRemainingTime(secondsLeft);
            if (secondsLeft === 0) setIsResendDisabled(false);
        };

        tick();
        // Sub-second polling + an immediate recalculation when the tab becomes
        // visible again, so the display corrects itself instantly on return.
        const timer = setInterval(tick, 500);
        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible") tick();
        };
        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            clearInterval(timer);
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, [isResendDisabled]);

    const handleResendClick = () => {
        if (isResendDisabled) return;

        deadlineRef.current = Date.now() + RESEND_WAIT_SECONDS * 1000; // Reset timer - 2 minutes
        setRemainingTime(RESEND_WAIT_SECONDS);
        setIsResendDisabled(true);
        props.signupUser(props.email, null);
    };

    const formatTime = (time) => {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };

    const handleSubmit = (e) => {

        e.preventDefault();
        if (!/^[0-9]+$/.test(otp)) {
            setEmailError("Verification code is required");
            return;
        } else if (otp.length < 6) {
            setEmailError("Verification code must be 6 digits long");
            return;
        }

        props.signupUser(props.email, otp);
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            if (!isResendDisabled) {
                e.preventDefault();
                e.stopPropagation();            // e.preventDefault(); // Prevent page reload
                return;
            }
            handleSubmit(e); // Optionally submit the OTP
            e.preventDefault();
            e.stopPropagation();            // e.preventDefault(); // Prevent page reload
        }
    };


    const handleBack = () => {

        props.setShowOtpComponent(false)
    }

    return (
        <div className="otp-verification-section">
            <div className="verification_code">
                <label>A Verification Code has been sent to your email: {props.email}</label>
                <div onKeyDown={handleKeyDown}>
                    <MuiOtpInputStyled
                        label="6-Digit Code"
                        fullWidth
                        margin="normal"
                        variant="outlined"
                        length={6}
                        name="code"
                        TextFieldsProps={{
                            size: "small",
                        }}
                        error={!!emailError}
                        value={otp}
                        onChange={handleOtpChange}
                        sx={{ paddingBottom: '15px', gap: "2px" }}
                    />
                </div>
                {emailError && (
                    <FormHelperText error>
                        {emailError}
                    </FormHelperText>
                )}
                <div className="otp-verification-container">
                    <div className="resend-verification-with-edit-email-folder">
                        {/* <button onClick={() => props.setShowOtpComponent(false)}>Edit Email</button> */}
                        <button onClick={() => handleBack()} >Edit Email</button>
                        <span className="Remaning_timer" onClick={handleResendClick} disabled={isResendDisabled}>
                            <span style={{ color: isResendDisabled && 'gray', cursor: isResendDisabled ? 'not-allowed' : 'pointer' }}>
                                {isResendDisabled ? "Resend Verification Code in " : "Resend Verification Code"} 
                            </span>
                            <span style={{ display: !isResendDisabled && 'none' }}>{formatTime(remainingTime)}</span>
                        </span>
                    </div>
                    <div className="signup-btn">
                        <button onClick={handleSubmit} style={{ cursor: props.loding ? 'not-allowed' : 'pointer' }} disabled={ props.loding} >
                            {location.state.status}
                        </button>
                    </div>
                </div>
            </div>
        </div >
    );
}
